import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const Parcel20Kg: FC<SvgIconProps> = ({ viewBox = '0 0 255 170', ...props }) => (
  <SvgIcon viewBox={viewBox} fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <path d="M105.864 80.601L206.833 62.48 149.136 34 48.166 51.753 105.865 80.6z" fill="#FDDE84" />
    <path opacity=".4" d="M81.084 68.026l100.969-17.753-9.616-4.808-101.34 18.123 9.987 4.438z" fill="#AA7B33" />
    <path d="M105.864 80.601v53.259l-57.697-28.848v-53.26l57.697 28.85z" fill="#C39000" />
    <path opacity=".4" d="M81.084 68.027v19.972l-9.987-5.178V63.588l9.987 4.439z" fill="#AA7B33" />
    <path d="M105.864 80.601v53.259l100.969-18.493V62.478L105.864 80.602z" fill="#FCCE09" />
    <path
      d="M239.4 88.6c0-5.2-12.9-9.6-28.6-9.6-15.7 0-28.6 4.4-28.6 9.6v37.2c0 5.2 12.9 9.6 28.6 9.6 15.7 0 28.6-4.4 28.6-9.6V88.6z"
      fill="#6D6D6D"
    />
    <path
      d="M239.4 125.8V88.6c0 2.3-2.5 4.6-6.9 6.3v37.2c4.4-1.8 6.9-4 6.9-6.3zM210.6 98.2c-15.8 0-28.6-4.4-28.6-9.6v37.2c0 5.2 12.9 9.6 28.6 9.6h4.6v-37c-1.3-.2-2.9-.2-4.6-.2z"
      fill="#6D6D6D"
    />
    <path
      d="M210.6 98.2c15.795 0 28.6-4.298 28.6-9.6S226.395 79 210.6 79c-15.795 0-28.6 4.298-28.6 9.6s12.805 9.6 28.6 9.6z"
      fill="#C8C8C8"
    />
    <path
      opacity=".05"
      d="M210.6 91.2c6.793 0 12.3-1.79 12.3-4 0-2.209-5.507-4-12.3-4-6.793 0-12.3 1.791-12.3 4 0 2.21 5.507 4 12.3 4z"
      fill="#000"
    />
    <path
      d="M214.1 87.5v-7.6c0-.6-1.6-1.1-3.6-1.1-1.9 0-3.6.5-3.6 1.1v7.4c0 .2.2.3.3.5.5.5 1.8.8 3.2.8 1.1 0 2.1-.2 2.7-.5.2 0 .2 0 .3-.2h.2s.2 0 .2-.2l.2-.2c.1.2.1.2.1 0z"
      fill="#555"
    />
    <path
      d="M222.8 72c0-2.3-5.5-4-12.3-4-6.8 0-12.3 1.8-12.3 4v6.9c0 2.3 5.5 4 12.3 4 6.8 0 12.3-1.8 12.3-4V72z"
      fill="#6D6D6D"
    />
    <path
      opacity=".1"
      d="M222.8 72c0-2.3-5.5-4-12.3-4-6.8 0-12.3 1.8-12.3 4v6.9c0 2.3 5.5 4 12.3 4 6.8 0 12.3-1.8 12.3-4V72z"
      fill="#fff"
    />
    <path
      d="M222.8 79v-6.9c0 1-1.1 1.9-2.9 2.6v6.9c1.8-.7 2.9-1.5 2.9-2.6zM210.6 76.1c-6.8 0-12.3-1.8-12.3-4V79c0 2.3 5.5 4 12.3 4h1.9v-6.9h-1.9z"
      fill="#6D6D6D"
    />
    <path
      d="M210.6 76c6.793 0 12.3-1.79 12.3-4s-5.507-4-12.3-4c-6.793 0-12.3 1.79-12.3 4s5.507 4 12.3 4z"
      fill="#C8C8C8"
    />
    <path
      d="M207.8 117.8v-2.6c1.5-1.7 2.2-2.6 3.7-4.3.3-.4.6-.7.7-1 .2-.3.2-.6.2-.9 0-.4-.1-.8-.3-1-.2-.2-.5-.3-.9-.3s-.8.1-1.1.4c-.3.2-.6.5-.9.9l-1.9-1.9c.5-.6 1-1.2 1.7-1.6.6-.4 1.5-.7 2.5-.7 1.2 0 2.3.2 3 .9.8.6 1.2 1.6 1.2 2.8 0 .6-.1 1.1-.3 1.6-.2.5-.5 1-.8 1.4-.3.5-.7 1-1.2 1.5-.6.8-1 1.1-1.6 1.9 1.6-.1 2.4-.1 4.1-.2v2.8c-3.2.3-4.9.3-8.1.3zM222 117c-1.6.3-2.7-.1-3.4-1.1-.7-1-1.1-2.4-1.1-4.3v-1.1c0-1.9.4-3.4 1.1-4.6.7-1.2 1.9-1.8 3.4-2.1 1.6-.3 2.7 0 3.4.8.7.9 1 2.3 1 4.2v1.1c0 1.9-.3 3.5-1 4.7-.8 1.3-1.9 2.1-3.4 2.4zm0-2.8c.5-.1.8-.4 1-1 .2-.6.3-1.5.3-2.7v-.8c0-1.2-.1-2.1-.3-2.6-.2-.5-.5-.7-1-.6-.5.1-.8.4-1 .9-.2.5-.3 1.4-.3 2.7v.8c0 1.2.1 2.1.3 2.6.2.6.5.8 1 .7zM210.9 129.3v-7.6c.8 0 1.2 0 1.9-.1v2.9h.5l1.5-3c.9-.1 1.3-.1 2.2-.2-.8 1.6-1.3 2.4-2.1 3.9.9 1.5 1.3 2.2 2.2 3.6-.9.1-1.4.1-2.3.2-.6-1.1-1-1.7-1.6-2.8h-.3v3c-.9 0-1.2.1-2 .1zM220.3 128.6c-1 .1-1.7-.1-2.2-.6-.5-.6-.8-1.4-.8-2.6v-.6c0-.8.1-1.4.4-2 .3-.6.6-1 1.1-1.4.5-.3 1-.6 1.6-.7 1-.2 1.8 0 2.4.6-.4.6-.7.9-1.1 1.5-.2-.2-.4-.3-.6-.4-.2-.1-.4-.1-.7 0-.4.1-.7.3-.9.6-.2.3-.3.9-.3 1.5v.5c0 .7.1 1.2.3 1.5.2.3.4.4.8.4.3-.1.6-.2.8-.5.2-.3.3-.6.3-1-.5.1-.7.1-1.1.2V124l3-.5v1.4c0 1-.3 1.9-.8 2.6-.6.5-1.3 1-2.2 1.1z"
      fill="#D3D1D1"
    />
    <path opacity=".2" d="M232.5 132s0-.2 0 0V94.8c-4.4 1.9-10 2.9-17.3 3.3v37c7.5-.2 12.9-1.2 17.3-3.1z" fill="#fff" />
  </SvgIcon>
)
